<h4 class="certification-name">{{ certification.name }}</h4>
<div class="show-more">
    <div class="show-more-details" *ngIf="showMore">
        <p class="show-more-details-item" *ngIf="!(workflowTypeId === WORKFLOW_MODULE_ID.TESTING_WORKFLOW)">
            <label class="label">Number of steps:</label> <span>{{ certification.steps_count }}</span>
        </p>
        <p class="show-more-details-item" *ngIf="!!certification.description">
            <label class="label">Description:</label>
            <cm-display-html [content]="certification.description"></cm-display-html>
        </p>
        <p class="show-more-details-item">
            <label class="label">Version: </label> <span>{{ certification.version }}</span>
        </p>
        <p class="show-more-details-item">
            <label class="label">Valid from: </label> <span>{{ certification.valid_from | dateFormat }}</span>
        </p>
        <p class="show-more-details-item">
            <label class="label">Valid to:</label> <span>{{ certification.valid_to | dateFormat }}</span>
        </p>
    </div>
    <span class="cm-link" (click)="toggleDetails($event)"> {{ showDetailsLabel }} </span>
</div>
